import { VIDEO_SELFIE } from 'constants/identityMethod';
import IDENTIFICATION_METHOD_MAPPER, {
    VIDEOSELFIE_METHODS_TYPES,
} from 'components/newAccountSteps/profileSteps/profileStep3/IdentificationMethod/constants/IdentificationMethodMapper';

export const getMethodTextsProps = (identificationMethod, isSelectedVideoselfieWithBiometrics = true) => {
    if (identificationMethod === VIDEO_SELFIE) {
        const type = isSelectedVideoselfieWithBiometrics
            ? VIDEOSELFIE_METHODS_TYPES.WITH_BIOMETRY
            : VIDEOSELFIE_METHODS_TYPES.WITHOUT_BIOMETRY;

        return IDENTIFICATION_METHOD_MAPPER[identificationMethod][type];
    }

    return IDENTIFICATION_METHOD_MAPPER[identificationMethod];
};
